import { createContext } from 'react';

interface IBaseListActionsContext {
  reloadList: () => void;
}

export const BaseListActionsContext = createContext<IBaseListActionsContext>({
  reloadList: () => {},
});
